export const Routes = Object.freeze({
    PROF_METRICS: {
        AGENTS: '/agent-name',
        AGENT_PROFILE: '/agent-detail',
        BASE: '/proficiency-metrics',
        COVERAGE_LISTING: '/agent-coverage-listing',
        LISTING_INFO: '/listing-info',
        OFFICE_NAME: '/office-name',
        PROD_LISTING: '/agent-production-listing',
        SAVED_AGENTS: '/saved-agents',
        SUGGESTED_AGENTS: '/suggested-agents',
        TRANSACTIONS: '/transactions',
        AGENT_MOVEMENT: '/agent-movement',
        AGENT_BREAKDOWN: '/agent-breakdown',
        AGENTS_GAINED: '/agent-breakdown',
        AGENTS_LOST: '/agent-lost',
        OFFICE_DETAILS: '/office-detail',
        OFFICE_LIST_BREAKDOWN: '/office-list-breakdown',
        ACTIVITY: '/activity',
        SETTINGS: '/settings',
    },
    MARKET_DYNAMICS: {
        BASE: '/market-dynamics',
        OFFICES_BREAKDOWN: '/office-breakdown',
        LISTINGS_BREAKDOWN: '/listings-breakdown',
        LISTING_INFO: '/listing-info',
        OFFICE_LISTING: '/office-listing',
    },
    MARKET_SHARE: {
        BASE: '/market-share',
        COVERAGE: '/coverage',
        LISTING_INFO: '/listing-info',
        OFFICES_BREAKDOWN: '/office-breakdown',
        OFFICE_LISTING: '/office-listing',
        TOTALS: '/totals',
    },
    MY_PROFILE: {
        BASE: '/my-profile',
        NOTIFICATIONS: '/notifications',
    },
    VALIDATION: {
        BASE: '/validation'
    },
    AUTH: {
        BASE: '/auth',
        LOG_IN: '/login',
        LOG_OUT: '/logout',
        CONNECT: '/connect',
        VERIFICATION_ERROR: '/verification-error',
    },
    HOME: {
        BASE: '/',
        DASHBOARD: '/dashboard',
    },
    AGENT_PRODUCTION: {
        BASE: '/agent-production',
    },
});

export const getPinnedRowRouteSettings = (route) => {
    return route.includes(Routes.MARKET_SHARE.OFFICES_BREAKDOWN) ? 'breakdown' : 'total';
};

export const nonModuleRoutes = [
    Routes.MY_PROFILE.BASE,
];
